import FetchData from '@ezviz/FetchData';
import intl from 'react-intl-universal';
import { message } from "antd";

// 获取类目列表数据
export const MANAGECATEGORY_FETCH_LIST_LOADING = 'MANAGECATEGORY_FETCH_LIST_LOADING';
export const MANAGECATEGORY_FETCH_LIST_SUCCESS = 'MANAGECATEGORY_FETCH_LIST_SUCCESS';
export const MANAGECATEGORY_FETCH_LIST_FAILED = 'MANAGECATEGORY_FETCH_LIST_FAILED';
// 添加大类
export const MANAGECATEGORY_ADD_MAINCATEGORY_LOADING = 'MANAGECATEGORY_ADD_MAINCATEGORY_LOADING';
export const MANAGECATEGORY_ADD_MAINCATEGORY_SUCCESS = 'MANAGECATEGORY_ADD_MAINCATEGORY_SUCCESS';
export const MANAGECATEGORY_ADD_MAINCATEGORY_FAILED = 'MANAGECATEGORY_ADD_MAINCATEGORY_FAILED';
// 修改大类
export const MANAGECATEGORY_EDIT_MAINCATEGORY_LOADING = 'MANAGECATEGORY_EDIT_MAINCATEGORY_LOADING';
export const MANAGECATEGORY_EDIT_MAINCATEGORY_SUCCESS = 'MANAGECATEGORY_EDIT_MAINCATEGORY_SUCCESS';
export const MANAGECATEGORY_EDIT_MAINCATEGORY_FAILED = 'MANAGECATEGORY_EDIT_MAINCATEGORY_FAILED';
// 删除大类
export const MANAGECATEGORY_DEL_MAINCATEGORY_LOADING = 'MANAGECATEGORY_DEL_MAINCATEGORY_LOADING';
export const MANAGECATEGORY_DEL_MAINCATEGORY_SUCCESS = 'MANAGECATEGORY_DEL_MAINCATEGORY_SUCCESS';
export const MANAGECATEGORY_DEL_MAINCATEGORY_FAILED = 'MANAGECATEGORY_DEL_MAINCATEGORY_FAILED';

// 添加小类
export const MANAGECATEGORY_ADD_SUBCATEGORY_LOADING = 'MANAGECATEGORY_ADD_SUBCATEGORY_LOADING';
export const MANAGECATEGORY_ADD_SUBCATEGORY_SUCCESS = 'MANAGECATEGORY_ADD_SUBCATEGORY_SUCCESS';
export const MANAGECATEGORY_ADD_SUBCATEGORY_FAILED = 'MANAGECATEGORY_ADD_SUBCATEGORY_FAILED';
// 修改小类
export const MANAGECATEGORY_EDIT_SUBCATEGORY_LOADING = 'MANAGECATEGORY_EDIT_SUBCATEGORY_LOADING';
export const MANAGECATEGORY_EDIT_SUBCATEGORY_SUCCESS = 'MANAGECATEGORY_EDIT_SUBCATEGORY_SUCCESS';
export const MANAGECATEGORY_EDIT_SUBCATEGORY_FAILED = 'MANAGECATEGORY_EDIT_SUBCATEGORY_FAILED';
// 删除小类
export const MANAGECATEGORY_DEL_SUBCATEGORY_LOADING = 'MANAGECATEGORY_DEL_SUBCATEGORY_LOADING';
export const MANAGECATEGORY_DEL_SUBCATEGORY_SUCCESS = 'MANAGECATEGORY_DEL_SUBCATEGORY_SUCCESS';
export const MANAGECATEGORY_DEL_SUBCATEGORY_FAILED = 'MANAGECATEGORY_DEL_SUBCATEGORY_FAILED';


// 获取类目列表数据
export function fetchManageCategoryList(param = {}) {
  return (dispatch, getState) => {
    const {
      pageStart = 0,
      pageSize = 10,
    } = param;
    dispatch({
      type: MANAGECATEGORY_FETCH_LIST_LOADING,
    });
    // 获取类目列表数据 待后台提供接口文档
    const url = `/iot/config/api/iot/support/category/mainCategory/list`;
    const body = {
      pageStart,
      pageSize,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGECATEGORY_FETCH_LIST_SUCCESS,
            categoryList: res.data || [],
            categoryListTotal: res.page.total || 0,
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGECATEGORY_FETCH_LIST_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGECATEGORY_FETCH_LIST_FAILED,
        });
      });
  };
}

// 添加大类
export function addMainCategory(param = {}, callback, fail) {
  return (dispatch, getState) => {
    const {
      label,
      mainCategory,
      subCatTags,
    } = param;
    dispatch({
      type: MANAGECATEGORY_ADD_MAINCATEGORY_LOADING,
    });

    const url = `/iot/config/api/iot/support/category/mainCategory/add`;
    const body = {
      label,
      mainCategory,
      subCatTags,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGECATEGORY_ADD_MAINCATEGORY_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGECATEGORY_ADD_MAINCATEGORY_FAILED,
          });
          fail && fail();
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGECATEGORY_ADD_MAINCATEGORY_FAILED,
        });
        fail && fail();
      });
  };
}
// 修改大类
export function editMainCategory(param = {}, callback, fail) {
  return (dispatch, getState) => {
    const {
      id,
      label,
      mainCategory,
      subCatTags,
    } = param;
    dispatch({
      type: MANAGECATEGORY_EDIT_MAINCATEGORY_LOADING,
    });

    const url = `/iot/config/api/iot/support/category/mainCategory/update`;
    const body = {
      id,
      label,
      mainCategory,
      subCatTags,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGECATEGORY_EDIT_MAINCATEGORY_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGECATEGORY_EDIT_MAINCATEGORY_FAILED,
          });
          fail && fail();
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGECATEGORY_EDIT_MAINCATEGORY_FAILED,
        });
        fail && fail();
      });
  };
}

// 删除大类
export function delMainCategory(param = {}, callback, fail) {
  return (dispatch, getState) => {
    const {
      id,
    } = param;
    dispatch({
      type: MANAGECATEGORY_DEL_MAINCATEGORY_LOADING,
    });

    const url = `/iot/config/api/iot/support/category/mainCategory/delete?id=${id}`;
    const fetchData = new FetchData(url, {
      method: 'POST',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGECATEGORY_DEL_MAINCATEGORY_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGECATEGORY_DEL_MAINCATEGORY_FAILED,
          });
          fail && fail();
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGECATEGORY_DEL_MAINCATEGORY_FAILED,
        });
        fail && fail();
      });
  };
}

// 添加小类
export function addSubCategory(param = {}, callback, fail) {
  return (dispatch, getState) => {
    const {
      pid,
      label,
      category,
      displayUrl,
      accessType,
      minAppVersion,
      tag,
      ext,
      netProtocols,
    } = param;
    dispatch({
      type: MANAGECATEGORY_ADD_SUBCATEGORY_LOADING,
    });

    const url = `/iot/config/api/iot/support/category/subCategory/add`;
    const body = {
      pid,
      label,
      category,
      displayUrl,
      accessType,
      minAppVersion,
      tag,
      ext,
      netProtocols,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGECATEGORY_ADD_SUBCATEGORY_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGECATEGORY_ADD_SUBCATEGORY_FAILED,
          });
          fail && fail();
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGECATEGORY_ADD_SUBCATEGORY_FAILED,
        });
        fail && fail();
      });
  };
}
// 修改小类
export function editSubCategory(param = {}, callback, fail) {
  return (dispatch, getState) => {
    const {
      id,
      pid,
      label,
      category,
      displayUrl,
      accessType,
      minAppVersion,
      tag,
      ext,
      netProtocols,
    } = param;
    dispatch({
      type: MANAGECATEGORY_EDIT_SUBCATEGORY_LOADING,
    });

    const url = `/iot/config/api/iot/support/category/subCategory/update`;
    const body = {
      id,
      pid,
      label,
      category,
      displayUrl,
      accessType,
      minAppVersion,
      tag,
      ext,
      netProtocols,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGECATEGORY_EDIT_SUBCATEGORY_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGECATEGORY_EDIT_SUBCATEGORY_FAILED,
          });
          fail && fail();
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGECATEGORY_EDIT_SUBCATEGORY_FAILED,
        });
        fail && fail();
      });
  };
}
// 删除小类
export function delSubCategory(param = {}, callback, fail) {
  return (dispatch, getState) => {
    const {
      id,
      categoryKey
    } = param;
    dispatch({
      type: MANAGECATEGORY_DEL_SUBCATEGORY_LOADING,
    });

    const url = `/iot/config/api/iot/support/category/subCategory/delete?id=${id}&categoryKey=${categoryKey}`;
    const fetchData = new FetchData(url, {
      method: 'POST',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGECATEGORY_DEL_SUBCATEGORY_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGECATEGORY_DEL_SUBCATEGORY_FAILED,
          });
          fail && fail();
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGECATEGORY_DEL_SUBCATEGORY_FAILED,
        });
        fail && fail();
      });
  };
}
